<template>
  <v-card>
    <v-card-title>車両</v-card-title>

    <v-card-text>
      <confirm-car v-if="bookCar" :car="bookCar"/>
      <hr class="has-space">
      <confirm-item em label="基本料金 小計" :charge="bookCharge.basic"/>
    </v-card-text>
  </v-card>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import ConfirmCar from './ConfirmCar'
import ConfirmItem from './ConfirmItem'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmCharge',
  mixins: [
    PartBase
  ],
  components: {
    ConfirmCar,
    ConfirmItem
  },
  computed: {
    ...mapGetters('book', [
      'bookCar',
      'bookCharge'
    ])
  }
}
</script>
